import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaUtensils, FaSearch, FaMobileAlt, FaCamera, FaCalendarAlt, FaListUl, FaEuroSign, FaUsers, FaRocket, FaCode, FaComments, FaStar } from 'react-icons/fa';
import Button from '../../components/Button';

const WebRestaurantesPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: '/servicios/diseno-web-pymes', text: 'Páginas web baratas para PYMES' },
    { url: '/servicios/diseno-web-autonomos', text: 'Páginas web baratas para autónomos' },
    { url: '/servicios/diseno-web-hoteles', text: 'Página web barata para hoteles' },
    { url: '/servicios/diseno-web-empresas', text: 'Páginas web baratas para empresas' },
    { url: '/precios', text: 'Ver todos nuestros precios' },
    { url: '/blog', text: 'Visita nuestro blog' }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Consigue reservas mientras tu restaurante está cerrado",
      description: "Tu web trabaja 24/7, permitiendo a clientes ver tu carta y reservar incluso de madrugada. Imagina abrir por la mañana y tener ya varias mesas reservadas."
    },
    {
      title: "Posiciónate por encima de competidores en Google",
      description: "El 78% de comensales buscan dónde comer en Google. Sin web, esos clientes acaban en otros restaurantes. Optimizamos tu web para aparecer cuando buscan restaurantes en tu zona."
    },
    {
      title: "Ahorra cientos de euros en plataformas de delivery",
      description: "Las apps de reparto cobran comisiones del 30% por pedido. Con tu web, puedes recibir pedidos directos sin intermediarios, aumentando significativamente tu margen."
    },
    {
      title: "Actualiza tu carta al instante, sin reimprimir",
      description: "¿Nuevos platos o cambios de precio? Actualiza tu carta digital al momento sin gastar en reimpresiones. Ideal para menús del día o promociones temporales."
    },
    {
      title: "Reduce las llamadas y optimiza tu personal",
      description: "Con un sistema de reservas online, reduces el tiempo que tu personal dedica a contestar llamadas, permitiéndoles centrarse en atender a los clientes presentes."
    },
    {
      title: "Inversión única con beneficios constantes",
      description: "Con tan solo 300€ de inversión inicial, obtienes un canal de reservas permanente. Unas pocas mesas ocupadas gracias a tu web ya recuperan la inversión varias veces."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaUtensils />,
      title: "Carta digital que estimula el apetito",
      description: "No es un simple PDF. Creamos una carta interactiva con fotografías profesionales de tus platos, descripciones apetitosas y marcado de alérgenos que además mejora tu SEO."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de reservas que llena tus mesas",
      description: "Integramos un sistema de reservas fácil de usar que reduce las llamadas perdidas y no requiere comisiones mensuales como otras plataformas de reservas."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles (donde más te buscan)",
      description: "El 81% de los clientes buscan restaurantes desde el móvil, a menudo mientras caminan por la calle. Tu web se adaptará perfectamente a cualquier pantalla."
    },
    {
      icon: <FaCamera />,
      title: "Galería de imágenes que vende por ti",
      description: "Las webs con fotos de calidad atraen un 191% más de reservas. Optimizamos las imágenes de tus platos, local y ambiente para despertar el deseo de visitar."
    },
    {
      icon: <FaSearch />,
      title: "Posicionamiento local que atrae clientes cercanos",
      description: "Configuramos tu web para que aparezca cuando alguien busca 'restaurantes cerca de mí' o términos relacionados con tu tipo de cocina en tu zona."
    },
    {
      icon: <FaEuroSign />,
      title: "Sin costes ocultos ni sorpresas",
      description: "Precio final desde 300€ (pago único) y mantenimiento fijo de 20€/mes. Sin comisiones por reserva, sin cargos extra por actualizaciones de carta."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Ideal para restaurantes pequeños que quieren iniciar su presencia online y atraer primeros clientes.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada. Para restaurantes que quieren destacar con un diseño más completo y mejor presencia.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para restaurantes que desean una web completa con todas las funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión para conocer tu restaurante",
      description: "Conversamos sobre tu cocina, valores, público objetivo y necesidades específicas. Te explicamos todo el proceso sin jergas técnicas para que entiendas cada paso.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web con un diseño que refleja la personalidad de tu restaurante. Implementamos tu carta digital, sistema de reservas y otros elementos clave para el sector.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y formación sencilla",
      description: "Activamos tu web y te enseñamos a gestionar reservas y actualizar tu carta sin complicaciones. Te damos consejos para promocionarla y comenzar a recibir reservas online.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Web especializada en sector hostelero",
      us: true,
      others: false
    },
    {
      label: "Precio final sin comisiones por reserva",
      us: true,
      others: false
    },
    {
      label: "Actualizaciones de carta ilimitadas",
      us: true,
      others: false
    },
    {
      label: "Sistema de reservas sin costes adicionales",
      us: true,
      others: false
    },
    {
      label: "Optimizada para búsquedas locales",
      us: true,
      others: false
    },
    {
      label: "Soporte rápido para cambios urgentes",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Nunca pensé que una web podría aportar tanto a nuestro restaurante. Pasamos de depender de plataformas que nos cobraban comisiones altísimas a recibir reservas directas. La web se pagó sola en menos de un mes solo con las comisiones que ahorramos. Y el equipo de Web a Bajo Coste hizo todo el proceso muy fácil.",
    author: "Miguel Ángel Rodríguez",
    position: "Propietario",
    company: "Restaurante La Terraza",
    avatar: "/servicios/testimonios/restaurante.webp"
  };
  
  // FAQs específicas para restaurantes
  const faqs = [
    {
      question: "¿Por qué necesito una web si ya estoy en plataformas como ElTenedor o Deliveroo?",
      answer: "Estas plataformas son útiles pero costosas: cobran comisiones del 15-30% por cada reserva o pedido, y no construyen tu marca sino la suya. Una web propia te permite: recibir reservas y pedidos sin comisiones, mostrar tu identidad sin restricciones, capturar datos de clientes directamente para marketing, aparecer en Google cuando buscan restaurantes en tu zona, y ofrecer promociones exclusivas sin pagar extra. La mayoría de nuestros clientes recuperan la inversión en solo 1-2 meses por el ahorro en comisiones.",
      category: "Estrategia"
    },
    {
      question: "¿Podré actualizar yo mismo la carta o dependeré de vosotros?",
      answer: "Todas nuestras webs para restaurantes incluyen un panel de administración sencillo que te permite actualizar precios, platos, o incluso el menú del día sin conocimientos técnicos. Te damos una breve formación de 15 minutos que será suficiente para que gestiones tu carta. Para cambios más complejos (como nuevas secciones o funcionalidades), podemos implementarlos por ti a precios muy razonables, o puedes solicitarlos a través del mantenimiento mensual sin coste adicional.",
      category: "Gestión"
    },
    {
      question: "¿Cómo funciona el sistema de reservas y tiene costes adicionales?",
      answer: "A diferencia de plataformas que cobran entre 1-2€ por comensal, nuestro sistema de reservas está incluido sin comisiones en los planes Profesional y Premium. El cliente selecciona fecha, hora y número de comensales, recibe confirmación automática por email, y tú recibes una notificación con los detalles. Además, incluye funcionalidades como gestión de disponibilidad por franjas horarias, recordatorios automáticos para reducir el no-show, y panel de administración para ver todas tus reservas. Si prefieres, también podemos integrar ElTenedor u otra plataforma que ya utilices.",
      category: "Reservas"
    },
    {
      question: "No tengo fotos profesionales de mis platos, ¿es un problema?",
      answer: "No te preocupes, podemos ayudarte. Ofrecemos tres opciones: 1) Te damos consejos para tomar fotos decentes con tu smartphone, 2) Tenemos colaboración con fotógrafos gastronómicos en varias ciudades que pueden hacer un reportaje por 150-300€, o 3) Iniciamos la web con fotos de stock de alta calidad relacionadas con tu tipo de cocina, y más adelante puedes ir reemplazándolas. Las fotos son muy importantes en hostelería; webs con imágenes profesionales de platos generan hasta un 191% más de reservas que las que no las tienen.",
      category: "Contenido"
    },
    {
      question: "¿La web incluirá sistema de pedidos a domicilio propio?",
      answer: "El plan Premium incluye un sistema básico de pedidos a domicilio sin comisiones. El cliente selecciona platos, completa sus datos, y tú recibes el pedido por email y/o WhatsApp para gestionarlo. Si buscas un sistema más complejo (con seguimiento en tiempo real, pagos online o gestión de repartidores), podemos desarrollarlo como un servicio adicional o recomendarte plataformas especializadas con menos comisiones que las grandes aplicaciones. Muchos de nuestros clientes restaurantes consiguen recuperar rápidamente su inversión solo con pedidos directos que antes pasaban por plataformas con altas comisiones.",
      category: "Funcionalidades"
    },
    {
      question: "¿En cuánto tiempo estará lista mi web de restaurante?",
      answer: "El tiempo de desarrollo es de 7-10 días desde la aprobación del diseño. Este plazo incluye: diseño personalizado según tu imagen de marca, implementación de la carta digital, configuración del sistema de reservas (en planes que lo incluyen), optimización SEO local y pruebas finales. Necesitaremos tu carta, información básica del restaurante y, preferiblemente, algunas fotografías. Para proyectos urgentes, ofrecemos un servicio express con entrega en 5 días laborables con un pequeño suplemento.",
      category: "Plazos"
    }
  ];

  const founderMessage = "Analizando el sector gastronómico, hemos comprobado que los restaurantes que destacan online ganan entre un 30-40% más de clientes nuevos. Sin embargo, muchos restaurantes tienen webs anticuadas o inexistentes que alejan a potenciales comensales. Creamos Web a Bajo Coste para cambiar esta situación con soluciones asequibles y efectivas.";
  
  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para restaurantes
      pageTitle="Páginas Web para Restaurantes desde 200€ | Diseño Web Profesional"
      pageDescription="Crea tu página web para restaurantes desde solo 200€. Diseño atractivo, optimizada para reservas, compatible con móviles y lista en 7 días. ¡Sin complicaciones!"
      pageKeywords="página web restaurante barata, diseño web restaurantes, web para restaurantes, web carta menu, web gastronomía"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-restaurantes"
      
      // Hero
      heroTitle="Web profesional para restaurantes desde 200€"
      heroSubtitle="Diseñamos webs que destacan tu gastronomía, atraen nuevos clientes y facilitan reservas. Sin costes ocultos, lista en 7 días y fácil de gestionar."
      heroImage="/servicios/tipo-cliente/restaurantes-hero.webp"
      badges={['Desde 200€ (pago único)', 'Carta online', 'Diseño atractivo', 'Soporte incluido']}
      heroCTAText="Consulta gratuita sin compromiso"
      heroCTALink="/reserva"
      
      // Pricing
      pricingTitle="Planes para tu página web de restaurante"
      pricingSubtitle="Elige el plan que mejor se adapte a tu negocio. Todos incluyen soporte técnico y mantenimiento obligatorio por 20€/mes."
      plans={plans}
      
      // Features
      featuresTitle="Diseño web especializado para restaurantes y hostelería"
      features={features}
      
      // Custom content
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      // Process
      processTitle="Creamos la web de tu restaurante en 3 pasos sencillos"
      processSteps={processSteps}
      
      // Comparison
      comparisonTitle="¿Por qué los restaurantes nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      // Benefits
      benefitsTitle="Ventajas de tener una web profesional para tu restaurante"
      benefits={benefits}
      
      // FAQ
      faqTitle="Preguntas frecuentes sobre webs para restaurantes"
      faqCategories={["General", "Funcionalidades", "Precios", "Proceso", "Mantenimiento"]}
      faqs={faqs}
      
      // CTA
      ctaTitle="Atrae más clientes a tu restaurante"
      ctaDescription="Da el primer paso hacia una presencia online que genere más reservas y pedidos"
      ctaButtonText="Solicitar información sin compromiso"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebRestaurantesPage; 

